import { getToken, getFarmData, clearStorage } from 'infra/services/auth'
import { fetchFarmById } from 'infra/services/farms'
import { fetchUser } from 'infra/services/users'
import { outdatedCache } from 'presentation/utils/storage/date'
import { getFarm, setFarm } from 'presentation/utils/storage/farm'
import { getUser, setUser } from 'presentation/utils/storage/user'
import { changeLanguage } from './../../../../i18n/locale'

export const makeAuth = async () => {
  try {
    if (!(getToken() && getFarmData())) {
      clearStorage()
      window.location.replace(`${process.env.REACT_APP_SIGNIN_URL}/logout`)
      return
    }

    const farmData = JSON.parse(getFarmData())
    const lastUpdated = await outdatedCache()
    const user = getUser()
    const farm = getFarm()

    if (lastUpdated || !user || !farm || (farmData.id !== farm?.id)) {
      const responseUser = await fetchUser()

      if (responseUser.data.type !== 'App') {
        clearStorage()
        window.location.href = `${process.env.REACT_APP_SIGNIN_URL}/logout`
        return
      }

      if (responseUser?.data?.languageMain) {
        changeLanguage(responseUser.data.languageMain)
      }

      setUser(responseUser.data)
      localStorage.setItem('user-id', btoa(responseUser.data.id))
      localStorage.setItem('user-name', btoa(responseUser.data.name))

      localStorage.setItem('farm-id', btoa(farmData.id))
      localStorage.setItem('farm-name', btoa(farmData.name))
      localStorage.setItem('farm-api-key', btoa(farmData.apiKeyId))

      const responseFarm = await fetchFarmById(farmData.id)
      setFarm(responseFarm.data)
    }
  } catch (error) {
    clearStorage()
    window.location.href = `${process.env.REACT_APP_SIGNIN_URL}/logout`
    console.error('Erro ao armazenar dados de Usuário.', error)
  }
}
